import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { BASE } from '../config/setting';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useSelector(state => state.auth);

  // Redirect after successful login
  useEffect(() => {
    if (token) {
      const from = location.state?.from || '/';
      navigate(from, { replace: true });
    }
  }, [token, navigate, location]);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await fetch(`${BASE}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Login failed');
      }

      const data = await response.json();

      // Check if 2FA setup is required
      if (data.requiresTwoFactorSetup) {
        localStorage.setItem('tempToken', data.tempToken);
        navigate('/2fa/setup');
        return;
      }

      // Check if 2FA verification is required
      if (data.requiresTwoFactor) {
        navigate('/2fa/verify', { state: { email, password } });
        return;
      }

      // Normal login success
      const { setCredentials } = await import('../features/auth/authSlice');
      dispatch(setCredentials({
        user: data.user,
        token: data.token
      }));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-5">
        <div className="card border-0 shadow-lg">
          <div className="card-body p-5">
            <div className="text-center mb-4">
              <div style={{ fontSize: '3.5rem' }}>🔐</div>
              <h2 className="mt-3">Welcome Back</h2>
              <p className="text-muted">Login to access your dashboard</p>
            </div>

            {error && (
              <div className="alert alert-danger d-flex align-items-center" role="alert">
                <span className="me-2">⚠️</span>
                <div>{error}</div>
              </div>
            )}

            <form onSubmit={submit}>
              <div className="mb-3">
                <label className="form-label fw-bold">📧 Email Address</label>
                <input 
                  className="form-control form-control-lg" 
                  type="email"
                  value={email} 
                  onChange={e => setEmail(e.target.value)}
                  disabled={loading}
                  placeholder="your.email@example.com"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="form-label fw-bold">🔑 Password</label>
                <input 
                  type="password" 
                  className="form-control form-control-lg" 
                  value={password} 
                  onChange={e => setPassword(e.target.value)}
                  disabled={loading}
                  placeholder="Enter your password"
                  required
                />
              </div>
              <button 
                className="btn btn-lg w-100 text-white fw-bold" 
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Logging in...
                  </>
                ) : (
                  <>Login →</>
                )}
              </button>
            </form>
            
            <div className="mt-3 text-center">
              <a href="/forgot-password" className="text-decoration-none">Forgot your password?</a>
            </div>
            
            {/* <div className="mt-4 p-3 bg-light rounded">
              <h6 className="mb-2">💡 Default Credentials:</h6>
              <small className="text-muted d-block">
                <strong>Email:</strong> superadmin@example.com<br/>
                <strong>Password:</strong> supersecret
              </small>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
